import { useState } from "react";
import html2canvas from "html2canvas";
import { ForwardedRef } from "react";

export const useTableImageActions = (resultRef: ForwardedRef<HTMLDivElement>, size: number) => {
	const [isLoadingTableCopied, setIsLoadingTableCopied] = useState(false);
	const [isTableCopied, setIsTableCopied] = useState(false);

	const copyTableAsImage = () => {
		if (resultRef && "current" in resultRef && resultRef.current) {
			setIsLoadingTableCopied(true);
			html2canvas(resultRef.current, { scale: size }).then((canvas) => {
				const scaleFactor = 1.5;
				const scaledCanvas = document.createElement("canvas");
				scaledCanvas.width = canvas.width * scaleFactor;
				scaledCanvas.height = canvas.height * scaleFactor;
				canvas.toBlob((blob) => {
					if (blob) {
						const item = new ClipboardItem({ "image/png": blob });
						navigator.clipboard.write([item]).then(
							() => {
								setIsTableCopied(true);
								setIsLoadingTableCopied(false);
								setTimeout(() => setIsTableCopied(false), 3000);
							},
							(err) => {
								setIsLoadingTableCopied(false);
								alert("Error al copiar al portapapeles: " + err);
							}
						);
					}
				});
			});
		}
	};

	const downloadTableAsImage = () => {
		if (resultRef && "current" in resultRef && resultRef.current) {
			html2canvas(resultRef.current, { scale: size }).then((canvas) => {
				const scaleFactor = 1.5;
				const scaledCanvas = document.createElement("canvas");
				scaledCanvas.width = canvas.width * scaleFactor;
				scaledCanvas.height = canvas.height * scaleFactor;
				canvas.toBlob((blob) => {
					if (blob) {
						const link = document.createElement("a");
						link.href = URL.createObjectURL(blob);
						link.download = "olly_tabla-ganadores.png";
						link.click();
					}
				});
			});
		}
	};

	return {
		isLoadingTableCopied,
		isTableCopied,
		copyTableAsImage,
		downloadTableAsImage,
	};
};
